//
// TooltipMapController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-gtl/models/layoutOverlayMap/map/MapPin";
import "@sas-dvr/ltjs-gtl/models/layoutOverlayMap/location/LocationFeature";
import "../../controllers/visualElements/MapElementController";

var TooltipMapController = createModule("BIRD::TooltipMapController", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getMapElementController: [1],
        cancelDriveTime: [0],
        doMultiDriveTime: [0,[5],4],
        doRadial: [0,5,4],
        canDoDriveTime: [2],
        getPin: [1],
        canDoDistanceSelections: [2],
        getFeature: [1],
    },
    ,
    ,
]);
export default TooltipMapController;
